import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import "./CustomSelect.scss";

/**
 * Custom Select component
 */
const CustomSelect = ({ options, id, classes = [], value, onChange, error }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedLabel, setSelectedLabel] = useState(""); // Wyświetlana etykieta
    const selectRef = useRef(null);

    // Aktualizacja wyświetlanej etykiety na podstawie wartości
    useEffect(() => {
        const selectedOption = options.find((opt) => opt.value === value);
        setSelectedLabel(selectedOption ? selectedOption.label : "Wybierz opcję");
    }, [value, options]);

    const handleOptionClick = (selectedValue) => {
        if (onChange) {
            onChange(selectedValue); // Przekazanie wartości do nadrzędnego komponentu
        }
        setIsOpen(false);
    };

    return (
        <div className={`custom-select ${classes.join(" ")}`} id={id}>
            {/* Ukryte <select>, ale dostępne dla walidacji */}
            <select
                ref={selectRef}
                id={id}
                name={id}
                value={value}
                onChange={() => {}} // Blokowanie domyślnego zachowania React
                className="visually-hidden"
                required
            >
                <option value="" disabled>
                    Wybierz opcję
                </option>
                {options.map(({ value: optionValue, label }) => (
                    <option key={optionValue} value={optionValue}>
                        {label}
                    </option>
                ))}
            </select>

            {/* Custom Select */}
            <div
                className={`custom-select__selected custom-select-placeholder ${error ? "error-border" : ""}`}
                onClick={() => setIsOpen((prev) => !prev)}
                tabIndex="0"
            >
                {selectedLabel || "Wybierz opcję"}
            </div>

            {/* Lista opcji */}
            {isOpen && (
                <div className="custom-select__options">
                    {options.map(({ value: optionValue, label }) => (
                        <span
                            key={optionValue}
                            className={`custom-select__option ${
                                optionValue === value ? "selected" : ""
                            }`}
                            onClick={() => handleOptionClick(optionValue)}
                        >
                            {label}
                        </span>
                    ))}
                </div>
            )}

            {/* Komunikat błędu */}
            {error && <span className="error-message">{error}</span>}
        </div>
    );
};

CustomSelect.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    id: PropTypes.string.isRequired,
    classes: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string, // Aktualna wartość przekazywana z nadrzędnego komponentu
    onChange: PropTypes.func.isRequired, // Callback wywoływany przy zmianie opcji
    error: PropTypes.string, // Komunikat błędu
};

export default CustomSelect;
